<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="关键字"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker type="daterange" size="small" :start-date="new Date()" placement="bottom-end"
                  placeholder="时间范围" style="width: 200px;margin-right: 3px;"
                  v-model="dateFilter"></DatePicker>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
    <process-true-hazard-event-modal v-model="processTrueHazardEventModal" :initValue="processTrueHazardEventId" @on-success="onModifySuccess"></process-true-hazard-event-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'
  import { genURLParams } from '@/libs/urlparamhelper'

  import ProcessTrueHazardEventModal from '@/view/gd-dlysjg/components/process-true-hazard-event-modal'

  export default {
    name: 'gddlysjgtruehazardevents',
    components: {
      ProcessTrueHazardEventModal
    },
    data () {
      return {

        processTrueHazardEventModal:false,
        processTrueHazardEventId:null,

        dateFilter: [],
        startDate: null,
        endDate: null,

        processStateFilter:[],
        processStateType:[{label:'未处理', value:1}, {label:'已处理', value:3}],

        asStatusFilter:[],
        asStatusType:[{label:'无', value:0}, {label:'有', value:1}],

        vehicleTypeNameFilter:[],
        vehicleTypeNameType:[{label:'重型货车', value:'重型货车'}, {label:'客运车辆', value:'客运车辆'}, {label:'危险货运', value:'危险货运'}],

        webTableColumnsModal: false,
        menuList: [
          { title: '设置表格列', content: {} }
        ],

        statusFilter: null,

        pageFilter: 30,
        pagesizeopts:[30, 50,100,200],
        keywordFilter: null,
        tableHeight: 160,
        pageIndex: 1,
        sort: null,
        listLoadding: false,

        columns: [
          {
            title: 'ID',
            resizable: true,
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            width: 80
          },
          {
            title: '报警名称',
            resizable: true,
            key: 'alarmCodeName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.alarmCodeName) {
                return h('div', params.row.alarmCodeName)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '是否有附件',
            resizable: true,
            key: 'asStatus',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160,
            filters: [{label:'无', value:0}, {label:'有', value:1}],
            filterMultiple: true,
            filterRemote: (val) => {
              if (val.length > 0) {
                this.asStatusFilter = []
                val.forEach(item => {
                  this.asStatusFilter.push(genQueryParam('asStatus', 'EQ', item))
                })
              } else {
                this.asStatusFilter = null
              }
            },
            render: (h, params) => {
              if (params.row.asStatus != null) {
                for (let i = 0; i < this.asStatusType.length; i++) {
                  if (params.row.asStatus == this.asStatusType[i].value) {
                    return h('label', this.asStatusType[i].label)
                  }
                }
              }
            }
          },
          {
            title: '车牌号',
            resizable: true,
            key: 'vehicleNo',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.vehicleNo) {
                return h('div', params.row.vehicleNo)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '车牌颜色',
            resizable: true,
            key: 'vehicleColorName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.vehicleColorName) {
                return h('div', params.row.vehicleColorName)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '车辆类型',
            resizable: true,
            key: 'vehicleTypeName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            filters: [{label:'重型货车', value:'重型货车'}, {label:'客运车辆', value:'客运车辆'}, {label:'危险货运', value:'危险货运'}],
            filterMultiple: true,
            filterRemote: (val) => {
              if (val.length > 0) {
                this.vehicleTypeNameFilter = []
                val.forEach(item => {
                  this.vehicleTypeNameFilter.push(genQueryParam('vehicleTypeName', 'EQSTR', item))
                })
              } else {
                this.vehicleTypeNameFilter = null
              }
            },
            render: (h, params) => {
              if (params.row.vehicleTypeName != null) {
                for (let i = 0; i < this.vehicleTypeNameType.length; i++) {
                  if (params.row.vehicleTypeName == this.vehicleTypeNameType[i].value) {
                    return h('label', this.vehicleTypeNameType[i].label)
                  }
                }
              }
            }
          },
          {
            title: '主机号',
            resizable: true,
            key: 'deviceId',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.deviceId) {
                return h('div', params.row.deviceId)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '业户名称',
            resizable: true,
            key: 'ownerName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 300,
            render: (h, params) => {
                if (params.row.ownerName) {
                  return h('div', params.row.ownerName)
                } else {
                  return h('div', '无')
                }
            }
          },
          {
            title: '三方监控单位',
            resizable: true,
            key: 'thirdPartyName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 300,
            render: (h, params) => {
              if (params.row.thirdPartyName) {
                return h('div', params.row.thirdPartyName)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '设备服务商',
            resizable: true,
            key: 'facilitatorName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 300,
            render: (h, params) => {
              if (params.row.facilitatorName) {
                return h('div', params.row.facilitatorName)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '设备厂商',
            resizable: true,
            key: 'producterName',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 300,
            render: (h, params) => {
              if (params.row.producterName) {
                return h('div', params.row.producterName)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '报警时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'alarmTime',
            width: 180,
            render: function (h, params) {
              if (params.row.alarmTime) {
                let d = new Date(params.row.alarmTime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '创建时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'createDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.createDatetime) {
                let d = new Date(params.row.createDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '处理状态',
            resizable: true,
            key: 'processState',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            filters: [{label:'未处理', value:1}, {label:'已处理', value:3}],
            filterMultiple: true,
            filterRemote: (val) => {
              if (val.length > 0) {
                this.processStateFilter = []
                val.forEach(item => {
                  this.processStateFilter.push(genQueryParam('processState', 'EQ', item))
                })
              } else {
                this.processStateFilter = null
              }
            },
            render: (h, params) => {
              if (params.row.processState != null) {
                for (let i = 0; i < this.processStateType.length; i++) {
                  if (params.row.processState == this.processStateType[i].value) {
                    return h('label', this.processStateType[i].label)
                  }
                }
              }
            }
          },
          {
            title: '处理备注',
            resizable: true,
            key: 'processRemark',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 300,
            render: (h, params) => {
              if (params.row.processRemark) {
                return h('div', params.row.processRemark)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '操作',
            resizable: true,
            key: 'action',
            align: 'left',
            ellipsis: 'true',
            fixed: 'right',
            width: 120,
            render: (h, params) => {

              let disp = []

              if(params.row.processState == 1){
                disp.push(h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      console.log('AA')
                      this.processTrueHazardEventId = params.row.id
                      this.processTrueHazardEventModal = true
                    }
                  }
                }, '处理'))
              }

              return h('div', disp)
            }
          }
        ]// cloumn
      }// return
    }, // data
    methods: {
      ...mapActions([
        'ClientInfoServ_GetPage'
      ]),
      /**
       * 表格右键回调
       */
      onTableRightClick (e) {
        this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
      },
      /**
       * 右键菜单点击回调
       */
      onContextMenuCallback (item) {
        if (item.title === '设置表格列') {
          this.webTableColumnsModal = true
        }
      },
      onSuccess () {
        this.setPage(1)
      },
      onModifySuccess () {
        this.refreshPage(this.pageFilter)
      },
      onFilterClick () {
        if (this.dateFilter.length==0) {
          this.startDate = null
          this.endDate = null
          this.setPage(1)
          return
        }
        if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
          this.startDate = null
          this.endDate = null
          this.setPage(1)
          return
        }
        let startDate = this.dateFilter[0]
        let endDate = this.dateFilter[1]
        this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
        this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
        this.setPage(1)
      },
      onExportExcelClick () {
        let queryParams = []
        let qo1 = null
        let qo2 = null
        if (this.stateFilter) {
          qo1 = this.stateFilter
        }
        if (this.offlineFilter) {
          qo2 = this.offlineFilter
        }
        if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
          let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
          let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
          queryParams.push(genQueryParam('analyzeDatetime', 'BTDT', startDatetime, endDatetime))
        }
        let urlparams = {
          qo1: qo1,
          qo2: qo2,
          q: queryParams,
          keyword: this.keywordFilter
        }
        let url = '/api/da/gddlysjgvehicleanalyzereport/exportexcel' + genURLParams(urlparams)
        window.location.href = url
      },
      filterChange () {
        this.setPage(1)
      },
      sortChange ({ column, key, order }) {
        this.sort = {
          name: key,
          asc: order === 'asc'
        }
        this.refreshPage(this.pageFilter)
      },
      setPage (page) {
        console.log('setPage' + page)
        this.pageIndex = page
        this.listLoadding = true

        let queryParams = []
        let sortParam = null
        let qo1 = null
        let qo2 = null
        let qo3 = null

        if (this.sort) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        }else{
          sortParam = genSortParam('alarmTime', false)
        }

        if(this.asStatusFilter){
          qo1 = this.asStatusFilter;
        }

        if(this.vehicleTypeNameFilter){
          qo2 = this.vehicleTypeNameFilter;
        }


        if(this.processStateFilter){
          qo3 = this.processStateFilter;
        }

        if (this.startDate && this.endDate) {
            queryParams.push(genQueryParam('alarmTime', 'BTDT', this.startDate, this.endDate))
        }

        store.dispatch('GdDlysjgTrueHazardEventServ_GetPage', {
          params: null,
          urlparams: {
            qo1: qo1,
            qo2: qo2,
            qo3: qo3,
            q: queryParams,
            ps: this.pageFilter,
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      // 刷新当前页
      refreshPage (value) {
        this.pageFilter = value
        this.setPage(this.pageIndex)
      }
    },
    computed: {
      totalElements () {
        if (store.getters.get_GdDlysjgTrueHazardEvent_GetPageResult) {
          return store.getters.get_GdDlysjgTrueHazardEvent_GetPageResult.totalElements
        } else {
          return 0
        }
      },
      content () {
        if (store.getters.get_GdDlysjgTrueHazardEvent_GetPageResult) {
          return store.getters.get_GdDlysjgTrueHazardEvent_GetPageResult.content
        } else {
          return []
        }
      },
      pageSize () {
        if (store.getters.get_GdDlysjgTrueHazardEvent_GetPageResult) {
          return store.getters.get_GdDlysjgTrueHazardEvent_GetPageResult.size
        } else {
          return 0
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.selectAnalysisDatetime = new Date()
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        window.onresize = () => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        }
        this.setPage(1)
      })
    }
  }
</script>

<style scoped>
</style>
